import { useEffect, useCallback } from 'react';

const LabelListeners = ({ eventEmitter, applyStoreAction }) => {
    const activityAdded = useCallback(activity => {
        applyStoreAction({
            type: 'ACTIVITY_ADD_SOCKET',
            payload: { activity }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('project_activity_added', activityAdded);

        return () => {
            eventEmitter.off('project_activity_added', activityAdded);
        };
    };

    useEffect(listen, [eventEmitter, activityAdded]);

    return null;
}

export default LabelListeners;
